// extracted by mini-css-extract-plugin
export default {"notification":"LockNotification_notification__UfrGy","slideIn":"LockNotification_slideIn__IkZwS"};